import { render, staticRenderFns } from "./SlCustomerDetailDebitNote.vue?vue&type=template&id=6d6296f2&lang=pug&"
import script from "./SlCustomerDetailDebitNote.vue?vue&type=script&lang=js&"
export * from "./SlCustomerDetailDebitNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SlCustomerDetailDebitNote.vue"
export default component.exports